import { useCallback, useEffect, useState } from 'react';
import { KeyValue } from '@mews/enums';

interface useKeyboardInteractionParams {
    active: boolean;
    onClose: () => void;
    deactivationKeys: KeyValue[];
}

export const useKeyboardInteraction = ({ active, deactivationKeys, onClose }: useKeyboardInteractionParams) => {
    const handleKeyDown = useCallback(
        (e: KeyboardEvent) => {
            if (deactivationKeys.includes(e.key as KeyValue)) {
                e.stopPropagation();
                if (active) {
                    onClose();
                }
            }
        },
        [deactivationKeys, active, onClose]
    );

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export const useVisibleWithDelay = (active: boolean, delay: number) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (active) {
            setIsVisible(true);
        } else {
            const timer = window.setTimeout(() => setIsVisible(false), delay);
            return () => window.clearTimeout(timer);
        }
    }, [active, delay]);

    return isVisible;
};
